<div cdkDropList class="block-list" [cdkDropListAutoScrollStep]="3" (cdkDropListDropped)="dropBlock($event)">
  @if (blocks.length === 0) {
    <div class="no-blocks-message">
      <p>{{ 'EMAIL_BUILDER.BLOCKS_LIST.HEADER' | translate }}</p>
      <p>
        <strong>{{ 'EMAIL_BUILDER.BLOCKS_LIST.ADD_NEW_BLOCK_HEADER' | translate }}</strong>
      </p>
    </div>
  }

  @for (block of blocks; track block; let index = $index; let first = $first; let last = $last) {
    <div cdkDrag class="block {{ block.type }}" [class.is-collapsed]="block.collapsed">
      <div *cdkDragPlaceholder class="block--placeholder"></div>
      <!-- Mobile Header -->
      <div class="block-header-mobile">
        <button
          mat-icon-button
          matTooltip=" {{ 'EMAIL_BUILDER.BLOCKS_LIST.MOVE_UP' | translate }} "
          class="block-header-button mobile-order-button"
          [disabled]="first"
          (click)="moveBlock(index, -1)"
        >
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <button
          mat-icon-button
          matTooltip=" {{ 'EMAIL_BUILDER.BLOCKS_LIST.MOVE_DOWN' | translate }} "
          class="block-header-button mobile-order-button"
          [disabled]="last"
          (click)="moveBlock(index, 1)"
        >
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <div class="block-header-text">
          {{ checkName(block.type) | async }}
          @if (block.collapsed) {
            <span class="is-collapsed">(collapsed)</span>
          }
        </div>
        @if (block.valid === false) {
          <mat-icon class="error-icon">error</mat-icon>
        }
        <!-- Using a switch case so it opens and closes without a delay -->
        @switch (block.collapsed) {
          @case (true) {
            <button
              mat-icon-button
              class="block-header-button mobile-actions-button"
              matTooltip=" {{ 'EMAIL_BUILDER.BLOCKS_LIST.EXPAND_TIP' | translate }} "
              (click)="block.collapsed = false"
            >
              <mat-icon>unfold_less</mat-icon>
            </button>
          }
          @case (false) {
            <button
              mat-icon-button
              class="block-header-button mobile-actions-button"
              matTooltip=" {{ 'EMAIL_BUILDER.BLOCKS_LIST.COLLAPSE_TIP' | translate }} "
              (click)="block.collapsed = true"
            >
              <mat-icon>unfold_more</mat-icon>
            </button>
          }
        }
        <button
          class="block-header-button block-header-menu mobile-actions-button"
          mat-icon-button
          [matMenuTriggerFor]="menu"
        >
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
      <!-- Desktop Header -->
      <div
        cdkDragHandle
        class="block-header-desktop"
        (dblclick)="block.collapsed = !block.collapsed; toggleAllBlocks(block.collapsed, $event)"
      >
        <mat-icon class="block-drag-handle" inline="true">drag_indicator</mat-icon>
        <div class="block-header-text">
          {{ checkName(block.type) | async }}
          @if (block.collapsed) {
            <span class="is-collapsed">(collapsed)</span>
          }
        </div>
        @if (block.valid === false) {
          <mat-icon class="error-icon">error</mat-icon>
        }
        <!-- Using a switch case so it opens and closes without a delay -->
        @switch (block.collapsed) {
          @case (true) {
            <button
              class="block-header-button"
              mat-icon-button
              (click)="block.collapsed = false; toggleAllBlocks(false, $event)"
              matTooltip=" {{ 'EMAIL_BUILDER.BLOCKS_LIST.EXPAND_TIP' | translate }} "
            >
              <mat-icon>unfold_less</mat-icon>
            </button>
          }
          @case (false) {
            <button
              class="block-header-button"
              mat-icon-button
              (click)="block.collapsed = true; toggleAllBlocks(true, $event)"
              matTooltip=" {{ 'EMAIL_BUILDER.BLOCKS_LIST.COLLAPSE_TIP' | translate }} "
            >
              <mat-icon>unfold_more</mat-icon>
            </button>
          }
        }
        <button mat-icon-button class="block-header-button block-header-menu" [matMenuTriggerFor]="menu">
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
      <!-- Individual Blocks -->
      <div class="block-controls">
        @switch (block.type) {
          @case ('image') {
            <email-image-block
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('heading') {
            <email-heading-block
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('rich_text') {
            <email-rich-text-block
              #richTextBlockElement
              [contentGenerationEnabled]="contentGenerationEnabled$ | async"
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('button') {
            <email-button-block
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('image_and_text') {
            <email-image-and-text-block
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('simple_table') {
            <email-simple-table-block
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('contact_card') {
            <email-contact-card
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          @case ('divider') {
            <email-divider-block [content]="$any(block.content)" />
          }
          @case ('spacer') {
            <email-spacer-block [content]="$any(block.content)" />
          }
          @case ('html') {
            <email-html-block
              [content]="$any(block.content)"
              (isBlockValid)="handleBlockValidityEvent($event, index)"
            />
          }
          <!-- TODO: Inject optional blocks via a factory instead-->
          @case ('review_request_links') {
            <email-review-request-links-block [content]="$any(block.content)" />
          }
          @case ('net_promoter_score') {
            <email-nps-block [content]="$any(block.content)" />
          }
        }
        <!-- Padding Footer -->
        @if (block.type !== 'spacer') {
          <mat-expansion-panel class="mat-elevation-z block-padding" [(expanded)]="block.showPadding">
            <mat-expansion-panel-header [expandedHeight]="'48px'">
              <mat-panel-title>{{ 'EMAIL_BUILDER.BLOCKS_LIST.PADDING' | translate }}</mat-panel-title>
              <mat-panel-description>
                <!-- Padding Top Summary -->
                @if (block.padding.top !== null) {
                  {{ block.padding.top }}px {{ 'EMAIL_BUILDER.BLOCKS_LIST.TOP' | translate }}
                  <!-- Comma shown if both padding top and bottom -->
                  @if (block.padding.top !== null && block.padding.bottom !== null) {
                    ,&nbsp;
                  }
                }
                <!-- Padding Bottom Summary -->
                @if (block.padding.bottom !== null) {
                  {{ block.padding.bottom }}px {{ 'EMAIL_BUILDER.BLOCKS_LIST.BOTTOM' | translate }}
                }
                <!-- Image and Text block padding between summary -->
                @if (block.type === 'image_and_text' && $any(block.content).paddingBetween !== null) {
                  <!-- Comma shown if either padding top and bottom -->
                  @if (block.padding.top !== null || block.padding.bottom !== null) {
                    ,&nbsp;
                  }
                  {{ $any(block.content).paddingBetween }}px {{ 'EMAIL_BUILDER.BLOCKS_LIST.BETWEEN' | translate }}
                }
              </mat-panel-description>
            </mat-expansion-panel-header>
            <email-block-padding [padding]="block.padding" />
            <!-- The "Image and Text" block has a special padding to control spacing between items -->
            @if (block.type === 'image_and_text') {
              <glxy-form-field suffixText="px">
                <glxy-label>{{ 'EMAIL_BUILDER.BLOCKS_LIST.SPACE_BETWEEN_ITEMS' | translate }}</glxy-label>
                <input
                  matInput
                  type="number"
                  name="Padding Between"
                  autocomplete="off"
                  inputmode="numeric"
                  placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                  pattern="[0-9]*"
                  (change)="refreshPreview()"
                  (keyup)="refreshPreview()"
                  [(ngModel)]="$any(block.content).paddingBetween"
                  emailHoldShiftToChangeNumberFieldByTen
                />
              </glxy-form-field>
            }
          </mat-expansion-panel>
        }
      </div>
      <!-- end .block-controls -->
    </div>
    <!-- end .block -->
    <!-- Block Menu -->
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="duplicateBlock(index)">
        <mat-icon>content_copy</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.DUPLICATE' | translate }}</span>
      </button>
      <button mat-menu-item [matMenuTriggerFor]="addNewBlockMenu" [matMenuTriggerData]="{ index: index }">
        <mat-icon>add</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.ADD_NEW_ABOVE' | translate }}</span>
      </button>
      <mat-divider />
      @if (!block.collapsed) {
        <button mat-menu-item (click)="block.collapsed = true">
          <mat-icon>unfold_less</mat-icon>
          <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.COLLAPSE' | translate }}</span>
        </button>
      }
      @if (block.collapsed) {
        <button mat-menu-item (click)="block.collapsed = false">
          <mat-icon>unfold_more</mat-icon>
          <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.EXPAND' | translate }}</span>
        </button>
      }
      <button mat-menu-item [matMenuTriggerFor]="blockOrderMenu">
        <mat-icon>swap_vert</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.ORDER' | translate }}</span>
      </button>
      <mat-divider />
      <button mat-menu-item (click)="deleteBlock(index)">
        <mat-icon>delete</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.DELETE' | translate }}</span>
      </button>
    </mat-menu>
    <mat-menu #blockOrderMenu="matMenu">
      <button mat-menu-item [disabled]="first" (click)="moveBlockToTop(index)">
        <mat-icon>vertical_align_top</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.MOVE_TO_TOP' | translate }}</span>
      </button>
      <button mat-menu-item [disabled]="first" (click)="moveBlock(index, -1)">
        <mat-icon>arrow_upward</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.MOVE_UP' | translate }}</span>
      </button>
      <button mat-menu-item [disabled]="last" (click)="moveBlock(index, 1)">
        <mat-icon>arrow_downward</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.MOVE_DOWN' | translate }}</span>
      </button>
      <button mat-menu-item [disabled]="last" (click)="moveBlockToBottom(index)">
        <mat-icon>vertical_align_bottom</mat-icon>
        <span>{{ 'EMAIL_BUILDER.BLOCKS_LIST.MOVE_TO_BOTTOM' | translate }}</span>
      </button>
    </mat-menu>
  }

  <div class="new-content-buttons-wrapper">
    <button mat-stroked-button color="primary" [matMenuTriggerFor]="addNewBlockMenu">
      <mat-icon>add</mat-icon>
      {{ 'EMAIL_BUILDER.BLOCKS_LIST.ADD_NEW' | translate }}
    </button>

    <glxy-button-group>
      <button mat-stroked-button (click)="openSuggestContentDialog()">
        <mat-icon svgIcon="galaxy-ai-icon" />
        {{ 'EMAIL_BUILDER.CONTENT_BLOCK_NAMES.SUGGEST_CONTENT' | translate }}
      </button>
      <button class="dropdown-icon" mat-stroked-button [matMenuTriggerFor]="suggestContentMenu">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </glxy-button-group>
  </div>

  <div class="drag-shield"></div>
</div>
<!-- end .list -->

<mat-menu #addNewBlockMenu="matMenu">
  <ng-template matMenuContent let-index="index">
    @for (item of blockNamesAndIcons; track item; let last = $last) {
      @if (item.id !== 'suggest_content') {
        <div class="mat-menu-item-flex-wrapper">
          <button mat-menu-item (click)="addNewBlock($any(item.id), $any(item.renderType), index)">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>
              {{ 'EMAIL_BUILDER.CONTENT_BLOCK_NAMES.' + item.id | uppercase | translate }}
            </span>
          </button>
          @if (item.id === 'button' && buttonRecipes.length > 0) {
            <button
              mat-menu-item
              class="block-recipes-menu-trigger"
              [mat-menu-trigger-for]="buttonRecipesMenu"
              [matMenuTriggerData]="{ index: index }"
            ></button>
          }
        </div>
      }
      @if (item.dividerAfter && !last) {
        <mat-divider />
      }
    }
  </ng-template>
</mat-menu>

<mat-menu #suggestContentMenu="matMenu">
  <ng-template matMenuContent let-index="index">
    @for (recipe of suggestContentRecipes; track recipe) {
      @switch (recipe.id) {
        @case ('suggest-text-content') {
          <button mat-menu-item class="recipes-menu-item" (click)="openSuggestContentDialog()">
            {{ recipe.name }}
          </button>
        }
        @case ('suggest-image-content') {
          <button mat-menu-item class="recipes-menu-item" (click)="openSuggestImageDialog()">
            {{ recipe.name }}
          </button>
        }
      }
    }
  </ng-template>
</mat-menu>

<mat-menu #buttonRecipesMenu="matMenu">
  <ng-template matMenuContent let-index="index">
    @for (recipe of buttonRecipes; track recipe; let last = $last) {
      @switch (recipe.id) {
        @case ('product-button') {
          <button mat-menu-item class="recipes-menu-item" (click)="openProductDialog({ index: index })" mat-menu-item>
            {{ recipe.name }}
            <div class="recipes-menu-item-source">{{ recipe.source }}</div>
          </button>
        }
        @default {
          <button class="recipes-menu-item" mat-menu-item (click)="addRecipe(recipe, '', index)">
            {{ recipe.name }}
            <div class="recipes-menu-item-source">{{ recipe.source }}</div>
          </button>
        }
      }
    }
  </ng-template>
</mat-menu>

<ng-template #productList let-data>
  <h2 mat-dialog-title>Select product for button</h2>
  <mat-dialog-content>
    <glxy-form-field>
      <input
        type="text"
        placeholder="Select product"
        matInput
        [formControl]="productSearchControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        @for (product of filteredProductList$ | async; track product) {
          <mat-option mat-dialog-close="" (click)="addRecipe(productButtonRecipe, product.appId, data.index)">
            <span>
              {{ product.name }}
            </span>
          </mat-option>
        }
      </mat-autocomplete>
    </glxy-form-field>
  </mat-dialog-content>
</ng-template>
